@let loadingValue = isLoading();
@let disableApplyValue = disableApplyy();
<div class="home-block" id="programs">
  <div class="container">
    <div class="text-container">
      <h1>Programok</h1>
      <div class="content-with-scrollbar">
        <ul *appFadeInOnScroll class="program-list fadeInit fadeInRight">
          @if (!loadingValue) {
            @for (p of presentations; track p) {
              <li>
                <span>{{ p.startAt | date: 'HH:mm' }} - {{ p.endAt | date: 'HH:mm' }}</span>
                <span>{{ p.name }}</span>
                <app-expandable-text [text]="p.description ?? ''" />
              </li>
            }
          }
          <div class="line-decor"></div>
        </ul>
      </div>
    </div>

    <div class="home-block" id="workshops">
      <div class="container">
        <div class="text-container">
          <h1>Kerekasztal-beszélgetések</h1>
          <div class="content-with-scrollbar">
            <ul *appFadeInOnScroll class="program-list fadeInit fadeInRight">
              @if (!loadingValue) {
                @for (w of workshops; track w) {
                  <li>
                    <span>{{ w.startAt | date: 'HH:mm' }} - {{ w.endAt | date: 'HH:mm' }}</span>
                    <span>{{ w.name }}</span>
                    <app-expandable-text [text]="w.description ?? ''" />
                  </li>
                }
              }
              <div class="line-decor"></div>
            </ul>
          </div>
          <div class="application-container">
            @if (!loadingValue && !(workshops | isNil) && workshops.length > 0) {
              <button
                id="apply-workshop"
                type="button"
                [disabled]="disableApplyValue"
                (click)="onOpenApplyWorkshop()"
              >
                <p>Jelentkezem</p>
                <div>
                  <img
                    alt=""
                    height="24"
                    loading="lazy"
                    src="/multimedia/home/cursor.webp"
                    width="24"
                  />
                </div>
              </button>
            }
            @if (disableApplyValue) {
              <p class="info-box"
                >A jelentkezés a kerekasztal-beszélgetésre céges regisztrációhoz kötött, de a
                program a szabad helyek függvényében megtekinthető!</p
              >
            }
          </div>
        </div>

        <div class="text-container">
          <h1>Szemináriumok</h1>
          <div class="content-with-scrollbar">
            <ul *appFadeInOnScroll class="program-list fadeInit fadeInRight">
              @if (!loadingValue) {
                @for (s of seminars; track s) {
                  <li>
                    <span>{{ s.startAt | date: 'HH:mm' }} - {{ s.endAt | date: 'HH:mm' }}</span>
                    <span>{{ s.name }}</span>
                    <app-expandable-text [text]="s.description ?? ''" />
                  </li>
                }
              }
              <div class="line-decor"></div>
            </ul>
          </div>
          <div class="application-container">
            @if (!loadingValue && !(seminars | isNil) && seminars.length > 0) {
              <button
                id="apply-workshop"
                type="button"
                [disabled]="disableApplyValue"
                (click)="onOpenApplySeminar()"
              >
                <p>Jelentkezem</p>
                <div>
                  <img
                    alt=""
                    height="24"
                    loading="lazy"
                    src="/multimedia/home/cursor.webp"
                    width="24"
                  />
                </div>
              </button>
            }
            @if (disableApplyValue) {
              <p class="info-box"
                >A jelentkezés a szemináriumra céges regisztrációhoz kötött, de a program a szabad
                helyek függvényében megtekinthető!</p
              >
            }
          </div>
        </div>
      </div>
    </div></div
  ></div
>
